export default __webpack_public_path__ + "static/media/GL_atterraggio_1920x1080.8ec9e598.mp4";